import { IHasDisplayName } from './sortByDisplayName';

export interface IHasId {
  id: string;
}

type THasDisplayNameAndId = IHasId & IHasDisplayName;

export default function addLabel(
  item: THasDisplayNameAndId,
  index?: number,
  array?: any[],
  additionToLabel?: string
): any {
  if (!item) {
    throw new Error(
      'Illegal argument: addLabel received NULL for its item parameter.'
    );
  }
  const newLabel = additionToLabel
    ? `${additionToLabel}${item.displayName}`
    : item.displayName;

  return { ...item, value: item.id, label: newLabel };
}
